import { useSyncExternalStore } from 'react'

let prefersViewportCorner = false
const listeners = new Set()

/**
 * Full-screen layers (e.g. book modal) call this so global chrome (floating chat)
 * can align to the viewport corner without importing feature-specific Redux state.
 */
export const setFloatingChatViewportCornerActive = (active) => {
  const next = Boolean(active)
  if (prefersViewportCorner === next) return
  prefersViewportCorner = next
  listeners.forEach((listener) => {
    listener()
  })
}

const subscribe = (listener) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const getSnapshot = () => prefersViewportCorner

const getServerSnapshot = () => false

export const useFloatingChatViewportCornerActive = () => (
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
)
